module.exports = __webpack_public_path__ + "img/carbon_delivery.01fbae0a.svg";